import { createIconInner } from '##/icons/Icon/createIconInner';

import props from './props';
import svg from './svg';

export const IconAlignBlocksLeft = createIconInner(props, svg);
